import React, { Fragment, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import moment from 'moment'
import { useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import ContentHeader from '../../../Layout/ContentHeader'
import Loader from '../../../Global/Spinner'
import Box from '../../../Global/Box'
import MapPointLocationAddress from '../../../Global/MapPointLocationAddress'
import InternalNotes from '../../../Global/InternalNotes/InternalNotes'
import TimeLines from '../../../Global/TimeLines/TimeLines'
import ProgressBarStatus from '../../../Global/ProgressBarStatus'
import { categorModule, categorStatusModule } from './WaterTruckRequest'
import {
  priorityOptions,
  typeDeliveryOptions,
} from './WaterTruckRequestNewAndEdit'
import { GET_WATER_TRUCK_BY_ID } from '../../../../graphql/Catalog/WaterTruckRequest/waterTruckRequest'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { GET_CAPACITY_TRUCKS } from '../../../../graphql/Catalog/Trucks/trucks'

const backPage = '/water-truck'

const getValuePriority = (priority) => {
  const exist = priorityOptions.find((item) => item.value === priority)
  return exist?.label || 'N/A'
}

const getValueTypeDelivery = (type_delivery) => {
  const exist = typeDeliveryOptions.find((item) => item.value === type_delivery)
  return exist?.label || 'N/A'
}

const dataAttachmentTypeFile = {
  pdf: {
    icon: 'fas fa-file-pdf',
    text: 'PDF',
  },
  img: {
    icon: 'fas fa-image',
    text: 'IMG',
  },
}

const WaterTruckRequestDetails = () => {
  const { id: _id } = useParams()

  const [data, setData] = useState(null)
  const [capacityOptions, setCapacityOptions] = useState([])

  const {
    data: dataCapacity,
    loading: loadingCapacity,
    error: errorCapacity,
  } = useQuery(GET_CAPACITY_TRUCKS, {
    fetchPolicy: 'cache-and-network',
  })

  const {
    data: dataResp,
    loading,
    error,
  } = useQuery(GET_WATER_TRUCK_BY_ID, {
    variables: { id: parseInt(_id) },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    if (!loading) {
      if (_id) {
        if (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }
        if (dataResp !== undefined && dataResp !== null) {
          const resp = dataResp.getOneWaterTruckRequestById
          setData(resp)
        }
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, dataResp, error, loading])

  useEffect(() => {
    try {
      if (loadingCapacity) return
      if (errorCapacity) throw errorCapacity
      if (!dataCapacity)
        throw new Error('No se encontraron datos de las capacidades')

      const { getCapacityForTruck } = dataCapacity

      setCapacityOptions(getCapacityForTruck)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingCapacity, errorCapacity, dataCapacity])

  const getValueVolume = (volume) => {
    const exist = capacityOptions.find((item) => item.value === volume)
    return exist?.label || 'N/A'
  }

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <Link
                  className="btn btn-migrates-white mb-3"
                  to={backPage}
                >
                  <i className="fas fa-long-arrow-alt-left" /> Atrás
                </Link>
                <h1 className="header-title">Pipa de agua</h1>
              </div>
            </div>
          </div>
        }
        breadcrumb=""
        windowTitle={`Detalle de pipa`}
      />

      {loading || !data ? (
        <div className="d-flex align-items-center justify-content-center">
          <Loader />
        </div>
      ) : (
        <div className="row reports-new-container">
          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 left-box">
            <div className="row">
              <div className="col-12">
                <div className="reports">
                  <Box
                    classNameHeader="card-header py-1"
                    contentHeader={
                      <>
                        <h3 className="card-title pl-3 mt-0">
                          Datos generales
                        </h3>
                        <div className={`card-tools mr-2`}>
                          <div
                            style={{ fontSize: 13 }}
                            className={` px-2 rounded`}
                          >
                            <ProgressBarStatus
                              category={categorModule}
                              status={data.StatusOfWaterTruckRequest}
                            />
                          </div>
                        </div>
                      </>
                    }
                    content={
                      <>
                        <div className="row">
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Folio</span>
                            <br />
                            <span>
                              {data && data.folio ? data.folio : 'N/A'}
                            </span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Volumen</span>
                            <br />
                            <span>{getValueVolume(data?.volume) || 'N/A'}</span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Prioridad</span>
                            <br />
                            <span>
                              {getValuePriority(data?.priority) || 'N/A'}
                            </span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">
                              Tipo de entrega
                            </span>
                            <br />
                            <span>
                              {getValueTypeDelivery(data?.type_delivery) ||
                                'N/A'}
                            </span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Proveedor</span>
                            <br />
                            <span>
                              {data?.ProviderOfWaterTruckRequest?.card_name ||
                                'N/A'}
                            </span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Zona</span>
                            <br />
                            <span className="content-details">
                              {data?.ZonesOfWaterTruckRequest?.name || 'N/A'}
                            </span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Colonia</span>
                            <br />
                            <span className="content-details">
                              {data?.ColonyOfWaterTruckRequest?.name || 'N/A'}
                            </span>
                          </div>

                          {data?.planning_date && (
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                              <span className="title-details">
                                Fecha planificada
                              </span>
                              <br />
                              <span>
                                {moment(data.planning_date).format(
                                  'DD/MM/YYYY'
                                )}
                              </span>
                            </div>
                          )}
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Comentarios</span>
                            <br />
                            <span className="content-details">
                              {data?.comments || 'N/A'}
                            </span>
                          </div>
                        </div>
                      </>
                    }
                  />
                </div>
              </div>

              <div className="col-12 reports">
                <BoxAddress address={data?.AddressOfWaterTruckRequest} />
              </div>

              <div className="col-12 reports">
                <BoxAttachments
                  attachments={data?.AttachmentsOfWaterTruckRequest}
                />
              </div>

              <div className="col-12 reports">
                <BoxUserCreated userCreated={data?.UserOfWaterTruckRequest} />
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 right-box">
            <div className="row">
              <div className="col-12">
                <InternalNotes
                  category_note={categorModule}
                  category_notes_status={categorStatusModule}
                  document_id={_id ? parseInt(_id) : 0}
                  flagSwitchInternalMode={false}
                />
              </div>
              <div className="col-12">
                <TimeLines
                  category={categorModule}
                  document_id={parseInt(_id)}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-6"></div>
          </div>
        </div>
      )}
    </>
  )
}

const BoxAttachments = ({ attachments }) => {
  const MySwal = withReactContent(Swal)

  const [grouped, setGrouped] = useState([])

  let imageWidth = 500
  let imageHeight = 440
  let flagKeepImageSize = false

  // Group attachments by user
  useEffect(() => {
    if (attachments && attachments?.length > 0) {
      const groupedAttachments = attachments.reduce((acc, attachment) => {
        const userId = attachment.UserOfWaterTruckRequestAttachment.id
        const userIndex = acc.findIndex((user) => user.user_id === userId)

        if (userIndex === -1) {
          acc.push({
            user_id: userId,
            user: attachment.UserOfWaterTruckRequestAttachment,
            attachments: [attachment],
          })
        } else {
          acc[userIndex].attachments.push(attachment)
        }
        return acc
      }, [])
      setGrouped(groupedAttachments)
    }
  }, [attachments])

  const switchFile = (type_file) => {
    return (
      <>
        {dataAttachmentTypeFile[type_file].text}
        <i className={`${dataAttachmentTypeFile[type_file].icon} fa-2x ml-2`} />
      </>
    )
  }

  const handleModalImage = (url) => {
    let resetImageSize = () => {
      imageWidth = 500
      imageHeight = 440
    }

    MySwal.fire({
      html: `
      <button id="increase-size-btn" class="btn btn-migrates" style="margin-bottom:10px;">
      Aumentar tamaño
      </button>
      <img src="${url}" style="display:block;margin:auto;width:${imageWidth}px;height:${imageHeight}px;" />
      `,
      didOpen: () => {
        const btn = document.getElementById('increase-size-btn')
        if (btn) {
          btn.onclick = () => {
            imageWidth = imageWidth + 300
            imageHeight = imageHeight + 300
            flagKeepImageSize = true
            MySwal.close()
            handleModalImage(url)
          }
        }
      },
      willClose: () => {
        if (!flagKeepImageSize) resetImageSize()
        else flagKeepImageSize = false
      },
      width: imageWidth + 40,
      heightAuto: false,
      customClass: {
        popup: '',
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
      confirmButtonText: 'Aceptar',
    })
  }

  return (
    <Box
      title={<TitleBox icon="fas fa-paperclip" text="Archivos adjuntos" />}
      classNameHeader="card-header py-1"
      content={
        <>
          {attachments?.length === 0 || grouped.length === 0 ? (
            'No hay archivos adjuntos'
          ) : (
            <div className="d-flex flex-wrap" style={{ gap: 10 }}>
              {grouped.map((item) => {
                return (
                  <Fragment key={item.user_id}>
                    <b style={{ width: '100%' }}>{`${item.user?.name} ${
                      item.user?.name && `(${item.user?.RoleOfUser?.role_name})`
                    }`}</b>

                    {item.attachments.map((attachment) => {
                      if (!attachment?.url) return null

                      return (
                        <div key={attachment.id} className="btn btn-light">
                          {attachment?.type_file === 'img' ? (
                            <a
                              className="link-primary documentLink"
                              style={{ textDecoration: 'none' }}
                              as="button"
                              title="Descargar"
                              onClick={() => handleModalImage(attachment.url)}
                            >
                              {switchFile(attachment?.type_file)}
                            </a>
                          ) : (
                            <a
                              className="link-primary documentLink"
                              style={{ textDecoration: 'none' }}
                              as="button"
                              href={attachment.url}
                              target="_blank"
                              rel="noreferrer"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Descargar"
                            >
                              {switchFile(attachment?.type_file)}
                            </a>
                          )}
                        </div>
                      )
                    })}
                  </Fragment>
                )
              })}
            </div>
          )}
        </>
      }
    />
  )
}

const BoxAddress = ({ address }) => {
  const title = <TitleBox icon="fas fa-map" text="Ubicacion" />

  if (!address) {
    return (
      <Box
        title={title}
        classNameHeader="card-header py-1"
        content={'Aun no hay direccion'}
      />
    )
  }

  const { address_full, latitude, longitude } = address

  return (
    <Box
      title={title}
      classNameHeader="card-header py-1"
      content={
        <>
          <div className="mb-2">
            <b>Direccion: </b> {address_full ? `${address_full}, ` : ''}
          </div>
          {latitude && longitude && (
            <MapPointLocationAddress
              latitude={latitude}
              longitude={longitude}
            />
          )}
        </>
      }
    />
  )
}

const BoxUserCreated = ({ userCreated }) => {
  const title = <TitleBox icon="fas fa-user" text="Datos del solicitante" />

  if (!userCreated) {
    return (
      <Box
        title={title}
        classNameHeader="card-header py-1"
        content={'No hay datos de usuario'}
      />
    )
  }

  const { name, first_name, last_name, email, phone } = userCreated

  return (
    <Box
      title={title}
      classNameHeader="card-header py-1"
      content={
        <>
          <table className="table-reports-users">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Correo</th>
                <th>Teléfono</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {`${name ?? ''} ${first_name ? ' ' + first_name : ''} ${
                    last_name ? ' ' + last_name : ''
                  }
                  `}
                </td>
                <td>{email || 'N/A'}</td>
                <td>{phone || 'N/A'}</td>
              </tr>
            </tbody>
          </table>
        </>
      }
    />
  )
}

const TitleBox = ({ icon, text }) => {
  return (
    <>
      <i className={`${icon} pr-1`} style={{ fontSize: 12 }} />
      {text}
    </>
  )
}

export default WaterTruckRequestDetails
